import * as olSource from 'ol/source'

export default function OSM() {
  return new olSource.OSM({
    attributions: [
      '<a  target="_blank" style="color: #2B6CB0;" href="https://huskroua-cbc.eu/">GEOSES</a>, <a  target="_blank" style="color: #2B6CB0;" href="https://www.sgo-penc.hu/index_eng.php">SGO</a>, <a  target="_blank" style="color: #2B6CB0;" href="https://www.bme.hu/?language=en">BME</a> ©  <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
    ]
  })
}
